import { Box, Container, Typography } from "@mui/material";

import React from "react";

type Props = {
    title: string;
    subTitle?: string;
};

const PageTitle = ({ title, subTitle }: Props) => (
    <Box
        sx={{
            mx: 0,
            my: 5
        }}
    >
        <Container>
            <Typography
                variant="h1"
                mt={4}
                mb={2}
                sx={{
                    textAlign: "center"
                }}
            >
                {title}
            </Typography>
            {subTitle && (
                <Typography variant="h3" component="h2" align="center" mt={2} mb={4}>
                    {subTitle}
                </Typography>
            )}
        </Container>
    </Box>
);

PageTitle.defaultProps = {
    subTitle: null
};

export default PageTitle;
